import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/Home.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/events",
    name: "events",
    component: () => import("../views/Events.vue")
  },
  {
    path: "/zoneDetails",
    name: "zoneDetails",
    component: () => import("../views/ZoneDetails.vue")
  },
  {
    path: "/companys",
    name: "companys",
    component: () => import("../views/Companys.vue")
  },
  {
    path: "/companyDetail/:id",
    name: "companyDetail",
    component: () => import("../views/CompanyDetail.vue")
  },
  {
    path: "/jobs",
    name: "jobs",
    component: () => import("../views/Jobs.vue")
  },
  {
    path: "/jobDetail/:id",
    name: "jobDetail",
    component: () => import("../views/JobDetail.vue")
  },
  {
    path: "/jobSearchProgress",
    name: "job-search-progress",
    component: () => import("../views/JobSearchProgress.vue")
  },
  {
    path: "/policy",
    name: "policy",
    component: () => import("../views/Policy.vue")
  },
  {
    path: "/feedback",
    name: "feedback",
    component: () => import("../views/Feedback.vue")
  },
  {
    path: "/aboutUs",
    name: "aboutUs",
    component: () => import("../views/AboutUs.vue")
  },
  {
    path: "/announcement",
    name: "announcement",
    component: () => import("../views/Announcement.vue")
  },
  {
    path: "/content/:id/:cmCommentId",
    name: "content",
    component: () => import("../views/Content.vue")
  },
  {
    path: "/servicehall",
    name: "servicehall",
    component: () => import("../views/Servicehall.vue")
  },
  {
    path: "/user",
    name: "user",
    component() {
      return import("../views/User.vue");
    }
  },
  {
    path: "/register",
    name: "register",
    component() {
      return import("../views/Register.vue");
    }
  },
  {
    path: "/forgotPassword",
    name: "forgotPassword",
    component() {
      return import("../views/ForgotPassword.vue");
    }
  },
  {
    path: "/resume",
    name: "resume",
    component: () => import("@/views/Resume.vue")
  },
  {
    path: "/resume/edit",
    name: "resume-editor",
    component: () => import("@/views/ResumeEditor.vue")
  },
  {
    path: "/resume/basic",
    name: "resume-basic",
    component: () => import("@/views/ResumeBasic.vue")
  },
  {
    path: "/resume/intention",
    name: "resume-intention",
    component: () => import("@/views/ResumeIntention.vue")
  },
  {
    path: "/resume/advantage",
    name: "resume-advantage",
    component: () => import("@/views/ResumeAdvantage.vue")
  },
  {
    path: "/resume/experience",
    name: "resume-experience",
    component: () => import("@/views/ResumeExperience.vue")
  },
  {
    path: "/resume/experience/:id",
    name: "resume-experience-params",
    component: () => import("@/views/ResumeExperience.vue")
  },
  {
    path: "/resume/education",
    name: "resume-education",
    component: () => import("@/views/ResumeEducation.vue")
  },
  {
    path: "/resume/education/:id",
    name: "resume-education-params",
    component: () => import("@/views/ResumeEducation.vue")
  },
  {
    path: "/resume/project",
    name: "resume-project",
    component: () => import("@/views/ResumeProject.vue")
  },
  {
    path: "/resume/project/:id",
    name: "resume-project-params",
    component: () => import("@/views/ResumeProject.vue")
  },
  {
    path: "*",
    redirect: "/"
  }
];

const router = new VueRouter({
  mode: "history",
  // base:
  //   process.env.NODE_ENV !== "production"
  //     ? process.env.BASE_URL
  //     : process.env.BASE_URL  ,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // return { x: 0, y: 0 };
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

export default router;
